export default {
    info: {
        name: 'Naše firma s.r.o.',
        logo: 'https://mipuro.cz/logo.png',
        logo_invert: 'https://mipuro.cz/logo_invert.png',
        moto: 'Děláme to srdcem',
        opening: 'PO - PÁ 9:00 AŽ 17:00',
        phone: '+420 737 845 061'
    },
    socialLinks: {
        facebook: 'https://www.facebook.com/Mipuro-183001392316614',
        linkedin: '',
        twitter: '',
        youtube: '',
        instagram: ''
    },
    settings: {
        captchaSiteKey: '',
        captchaTheme: 'light',
        contactFormServer: {
            backendServer: 'https://dynamic-webs-server.herokuapp.com',
            host: '',
            port: 0,
            secure: true,
            auth: {
                user: '',
                pass: '',
            },
        recipients: []
        }
    },
    sections: [
        {
            type: 'SIMPLE_HEADER'
        },
        {
            type: 'SECTION_MENU',
            color: 'main-color'
        },
        {
            type: 'SLIDER',
            class: 'scroll_slider',
            content: {
                slides: [
                    {
                        image: 'https://mipuro.cz/img/repair.jpg',
                        title: 'Řemeslné práce',
                        text: 'Naši odborníci se postarají o zednické práce, rychle si poradí s obklady a dlažbou. Zajišťujeme drobné opravy, provádíme sádrokartonářské páce. Na nás se můžete vždy spolehnout!',
                        direction: 'center'
                    },
                    {
                        image: 'https://mipuro.cz/img/grass_cut.jpg',
                        title: 'Projektování a realizace zahrad',
                        text: 'Kompletní projektování zahrad dle Vašich přání včetně úpravy a případné údržby. Provádíme 3D vizualizace pro Vaši dokonalou představu.',
                        direction: 'left'
                    },
                    {
                        image: 'https://mipuro.cz/img/clean.jpg',
                        title: 'Úklidové práce',
                        text: 'Poskytujeme úklid domů čistícími stroji značek Kärcher a Nilfisk. Odvezeme stavební suť, zeminu, kamení a jiný stavební odpad. Uklidíme sníh a zajistíme jeho odvoz.',
                        direction: 'right'
                    }
                ]
            }
        },
        {
            type: 'SIMPLE_TEXT',
            sectionType: 'WHITE',
            class: 'scroll_about',
            showInMenu: false,
            content: {
                title: 'Mipuro s.r.o.',
                text: '<p style="font-size:1.4em;">Vám nabízí služby ohledně zahradnictví, úklidových prací, poskytnutí kontejnerů a&nbsp;řemeslných prací. Dále nabízíme strojové čištění eskalátorů a garáží. A v neposlední řadě také práce minibagříkem AVANT.</p>'
            }
        },
        {
            type: 'BRICKS',
            class: 'scroll_service',
            sectionType: 'SOFT_MAIN_COLOR',
            showInMenu: true,
            title: 'Naše služby',
            content: {
                title: 'Naše služby',
                bricks: [
                    {
                        title: 'Projektování zahrad',
                        text: 'Pokud toužíte po&nbsp;hezké zahradě, nabízíme odborné návrhy zahrad. Pro každý návrh zahrady potřebujeme: znát místo, jeho polohu a&nbsp;kvalitu půdy. Na&nbsp;návrhu zahrady se&nbsp;podílí zahradní architekt, který musí sladit jednotlivé živé a&nbsp;neživé prvky zahrady.',
                        image: 'https://mipuro.cz/img/planovani_zahrad.jpg'
                    },
                    {
                        title: 'Údržba zeleně',
                        text: 'Mezi služby údržby zeleně nabízíme sekání trávy, prořezávání keřů, zmlazování a&nbsp;průklest stromů, zalévání zahrady.',
                        image: 'https://mipuro.cz/img/udrzba_zelene.jpg'
                    },
                    {
                        title: 'Kontejnery',
                        text: 'Likvidace odpadu je&nbsp;součástí každého většího úklidu nebo rekonstrukce. Z&nbsp;vlastní zkušenosti přitom zajisté víte, že&nbsp;je&nbsp;lepší, pokud se&nbsp;nepotřebných předmětů a&nbsp;materiálů zbavíte co&nbsp;možná nejdříve.',
                        image: 'https://mipuro.cz/img/kontejner.jpg'
                    },
                    {
                        title: 'Řemeslné práce',
                        text: 'Mezi služby řemeslných prací patří zejména zednické práce,sádrokartonářské a&nbsp;drobné instalaterské práce.',
                        image: 'https://mipuro.cz/img/builder.jpg'
                    }
                ]
            }
        },
        {
            type: 'CROSS_TEXT',
            class: 'scroll_uklid',
            showInMenu: true,
            title: 'Úklidové práce',
            content: {
                title: 'Úklidové práce',
                parts: [
                    {
                        title: 'Úklid domů Praha',
                        text: 'K úklidu domů využíváme kvalitní techniku čistících strojů značek Kärcher a Nilfisk.'
                    },
                    {
                        title: 'Odvoz suti a zeminy',
                        text: 'Po stavebních pracích nebo úpravách zahrady může na Vašem pozemku zůstat množství materiálu, který je třeba odvézt. Díky spolehlivému nákladnímu autu Avia s kontejnerem je pro nás odvoz suti a odpadu hračkou. 3 m3 tříděné suti pro Vás odvezeme již za 1500 Kč včetně DPH, další ceny našich úklidových služeb najdete v ceníku.'
                    },
                    {
                        title: 'Úklid sněhu',
                        text: 'V zimě může i v Praze napadnout náhle velké množství sněhu. Myslete proto včas na zajištění zimních úklidových prací. Sníh na chodníku totiž může být i nebezpečný a za případné zranění můžete být odpovědní. Proto je lepší najít si spolehlivou firmu, která se o úklidové práce v zimě postará za Vás. Úklid sněhu zajišťují naši zkušení zaměstnanci, kteří se od jara do podzimu starají o zahrady. Odvoz sněhu zajišťují naše "multikáry", které nezastaví žádná závěj.'
                    }
                ]
            }
        },
        {
            type: 'PARALLAX',
            class: 'scroll-garden',
            showInMenu: true,
            title: 'Realizace zahrad',
            content: {
                image: 'https://mipuro.cz/img/garden_project.jpg',
                title: 'Krok za krokem od projektování zahrady po realizaci',
                sections: [
                    {
                        type: 'STEPS',
                        steps: [
                            '<strong>Zavolejte nám: </strong>Domluvíme si&nbsp;termín, kdy Vás navštívíme na&nbsp;pozemku, který se&nbsp;má&nbsp;stát zahradou.',
                            '<strong>Navštívíme Vaši zahradu, zjistíme Vaše podrobné požadavky a&nbsp;základní parametry zahrady: </strong>První návštěva na&nbsp;Vaší zahradě je&nbsp;velice důležitá, abychom posoudili prostor, ve&nbsp;kterém bude zahrada realizována. Společně určíme prvky, které budou zahradu tvořit. Někomu se&nbsp;více líbí divočejší zahrada s&nbsp;malou lavičkou, jiný upřednostňuje strukturovanou zahradu s&nbsp;velkým bazénem. Návštěva před projektováním zahrady nám také pomůže načerpat inspiraci pro kreativní návrh.',
                            '<strong>Sestavíme rozpočet na&nbsp;návrh i&nbsp;realizaci: </strong>Položku po&nbsp;položce přehledně rozepíšeme, kolik zaplatíte za&nbsp;návrh, kolik za&nbsp;případnou realizaci u&nbsp;nás.',
                            '<strong>Provedeme návrh zahrady: </strong>Rozsah návrhů zahrad je&nbsp;velmi individuální, ale obvykle obsahuje průvodní zprávu, výkres koncepce zahrady a&nbsp;seznam plánovaných rostlin. Na&nbsp;přání vytvoříme také 3D vizualizaci budoucí zahrady.',
                        ]
                    }
                ]
            }
        },
        {
            type: 'TABS',
            class: 'scroll_pricelist',
            sectionType: 'WHITE',
            showInMenu: true,
            title: 'Ceník',
            content: {
                title: 'Ceník služeb',
                text_top: '',
                text_bottom: '',
                tabs: [
                    {
                        title: 'Zahradní práce',
                        sections: [
                            {
                                type: 'TABLE',
                                data: [
                                    {
                                        cols: ['Sečení travnatých ploch', 'od 1,40 Kč/m2']
                                    },
                                    {
                                        cols: ['Sečení travnatých ploch křovinořezem', 'od 2,50 Kč/m2']
                                    },
                                    {
                                        cols: ['Řez keřů', 'od 20,- Kč/m2']
                                    },
                                    {
                                        cols: ['Řez živého plotu', 'od 13,- Kč/m2']
                                    },
                                    {
                                        cols: ['Hrabání listí', 'od 1,50 Kč/m2']
                                    },
                                    {
                                        cols: ['Pletí', 'od 9,- Kč/m2']
                                    },
                                    {
                                        cols: ['Výsběr papírků', 'od 0,40 Kč/m2']
                                    },
                                    {
                                        cols: ['Úklid košů', 'od 50,- Kč/ks']
                                    },
                                    {
                                        cols: ['Pokácení stromů dle velikosti', 'od 1220,- Kč/ks']
                                    },
                                    {
                                        cols: ['Prořez stromů', 'od 240,- Kč/h']
                                    },
                                    {
                                        cols: ['Odstranění drnu od chodníků, kantování', 'od 2,20 Kč/m2']
                                    },
                                    {
                                        cols: ['Založení trávníků', 'od 50,- Kč/m2']
                                    },
                                    {
                                        cols: ['Chemický postřik', 'od 5,- Kč/m2']
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        title: 'Úklidové práce',
                        sections: [
                            {
                                type: 'TABLE',
                                data: [
                                    {
                                        cols: ['Zimní úklid (s posypem)', 'od 2,- Kč/m2']
                                    },
                                    {
                                        cols: ['Pravidelný úklid vnitřních prostor', 'od 0,50 Kč/m2']
                                    },
                                    {
                                        cols: ['Generální a jednorázový úklid', 'od 1,50 Kč/m2']
                                    },
                                    {
                                        cols: ['Mytí oken, rámů a portálů', 'od 50,- Kč/m2']
                                    },
                                    {
                                        cols: ['Mytí prosklené plochy a výlohy', 'od 8,- Kč/m2']
                                    },
                                    {
                                        cols: ['Kompletní úklid po řemeslnících', 'od 150,- Kč/hod']
                                    },
                                    {
                                        cols: ['Čištění graffiti', 'od 100,- Kč/m2']
                                    },
                                    {
                                        cols: ['Čištění garáží', 'od 2,50 Kč/ks']
                                    },
                                    {
                                        cols: ['Nespecifikované práce', 'od 150,- Kč/h']
                                    },
                                    {
                                        cols: ['Dopravné', '200,- Kč']
                                    }
                                ]
                            },
                            {
                                type: 'INFO_TEXT',
                                content: {
                                    text: '<p>Dále provádíme drobné údržbářské práce.<br/>Kalkulace ceny se odvíjí od množství, četnosti a použité technologie.<br/>Při sjednávání zakázky je cena upřesněna v dohodě se zákazníkem, dle skutečného stavu.</p>'
                                }
                            }
                        ]
                    },
                    {
                        title: 'Odvoz odpadu',
                        sections: [
                            {
                                type: 'TABLE',
                                data: [
                                    {
                                        cols: ['3m3 netříděná suť', '3.000,-']
                                    },
                                    {
                                        cols: ['3m3 odpad do 1 t', '2.600,-']
                                    },
                                    {
                                        cols: ['3m3 odpad nad 1 t', '3.200,-']
                                    },
                                    {
                                        cols: ['5m3 odpad zvýšený', '3.700,-']
                                    },
                                    {
                                        cols: ['9m3 odpad velký', '4.900,-']
                                    },
                                    {
                                        cols: ['9m3 odpad roští, listí, větve, bio odpad', '4.000,-']
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        title: 'Zednické práce',
                        sections: [
                            {
                                type: 'TABLE',
                                data: [
                                    {
                                        cols: ['Zdivo do 45 cm', '400 - 700,- Kč/m3']
                                    },
                                    {
                                        cols: ['Omítky jádrové do 20 mm', '90,- Kč/m2']
                                    },
                                    {
                                        cols: ['Omítky jádrové nad 20 mm', '120,- Kč/m2']
                                    },
                                    {
                                        cols: ['Penetrace disperzí', '10,- Kč/m2']
                                    },
                                    {
                                        cols: ['Štukování - stěna', '50 - 70,- Kč/m2']
                                    },
                                    {
                                        cols: ['Štukování - strop', '80 - 100,- Kč/m2']
                                    },
                                    {
                                        cols: ['Malování (primalex)', '15 - 25 Kč/m2']
                                    },
                                    {
                                        cols: ['Betonáž podlah do 50 mm', '80,- Kč/m2']
                                    },
                                    {
                                        cols: ['Betonáž podlah 50 - 150 mm', '120,- Kč/m2']
                                    },
                                    {
                                        cols: ['Dlažby', '240 - 350,- Kč/m2']
                                    },
                                    {
                                        cols: ['Obklady', '220 - 330,- Kč/m2']
                                    },
                                    {
                                        cols: ['Zámková dlažba', '180 - 300,- Kč/m2']
                                    },
                                    {
                                        cols: ['Obrubníky betonové', '100 - 150,- Kč/bm']
                                    },
                                    {
                                        cols: ['Zednické práce hodinové', '200,- Kč/hod']
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        title: 'Sádrokartonářské práce',
                        sections: [
                            {
                                type: 'TABLE',
                                data: [
                                    {
                                        cols: ['Sádrokartonové příčky', '220 - 250,- Kč/m2']
                                    },
                                    {
                                        cols: ['Sádrokartonové stropy ploché', '200,- Kč/m2']
                                    },
                                    {
                                        cols: ['Sádrokartonové stropy šikmé, arkýře', '220 - 280,- Kč/m2']
                                    }
                                ]
                            },
                            {
                                type: 'INFO_TEXT',
                                content: {
                                    text: '<p>Kalkulace ceny se odvíjí od množství, četnosti a použité technologie.<br/>Při sjednávání zakázky je cena upřesněna v dohodě se zákazníkem, dle skutečného stavu.</p>'
                                }
                            }
                        ]
                    }
                ]
            }
        },
        {
            type: 'SIMPLE_CONTACT',
            class: 'scroll_contact',
            showInMenu: true,
            title: 'Kontakt',
            content: {
                address: {
                    street: 'Nad  Meandry ',
                    city: 'Praha 10, Zahradní město',
                    psc: '106 00',
                    map_src: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2552.917180857766!2d14.503473340616353!3d50.05295252428162!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x470b9253baca60d5%3A0x3203cbd938ca9f9e!2sNad+Meandry%2C+106+00+Praha+10!5e0!3m2!1scs!2scz!4v1517393388699'
                },
                email: 'mipuro@seznam.cz'
            }
        },
        {
            type: 'MADE_BY',
            class: 'scroll_madeby',
            sectionType: 'THIN_DARK',
            showInMenu: false,
            content: '<div>© 2018 <a href="https://2gispraha.cz" target="_blank" rel="noopener noreferrer">2GIS</a></div>'
        }
    ]
}


// WEBPACK FOOTER //
// ./src/_main_data.js